import { Tabs as MuiTabs, withStyles } from '@material-ui/core';

import { colors } from '../styles';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const PanelTabs = withStyles({
  root: {
    width: '100%',
    borderRadius: '5px 5px 0px 0px',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      width: 'auto',
      backgroundColor: colors.gray.light,
      height: '1px',
      borderRadius: '2px',
    },
  },
  indicator: {
    backgroundColor: colors.primary.default,
    height: '3px',
    borderRadius: '2px',
    bottom: 0,
  },
})(MuiTabs);
